import React, {Component} from 'react';
import axios from 'axios';
import {FaCloud} from "react-icons/fa";
import { connect } from 'react-redux';
import { Col, Row, Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import DetailProductVpsComponent from "../../../components/Customer/products/DetailProductVpsComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import {Link} from "react-router-dom";

class ListProductVpsByUserPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listProduct: [],
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isSpinner: false,
            actionKey: 0,
            configBilling: {
                'monthly' : '1 Tháng',
                'twomonthly' : '2 Tháng',
                'quarterly' : '3 Tháng',
                'semi_annually' : '6 Tháng',
                'annually' : '1 Năm',
                'biennially' : '2 Năm',
                'triennially' : '3 Năm',
                'one_time_pay' : 'Vĩnh viễn',
                'free' : 'Miễn phí',
            },
            listGroupProduct: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.listProductByGroupProduct();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    listProductByGroupProduct = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/product/listProductVpsByUser',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listProduct: ref.data.listProduct,
                        listGroupProduct: ref.data.listGroupProduct,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    loadProductVps = () => {
        if (this.state.listProduct.length) {
            return (
                this.state.listProduct.map((product, key) => (
                    <DetailProductVpsComponent
                        key={key}
                        actionKey={key}
                        product={product}
                        changeBillingCycle={ (actionKey, billing) => this.changeBillingCycle(actionKey, billing) }
                    />
                ))
            )
        }
    }

    changeBillingCycle = (actionKey, billing) => {
        // console.log(billing)
        let listProduct = this.state.listProduct;
        let text_pricing = this.addCommas(listProduct[actionKey].product_pricing[billing]);
        let text_billing_cycle = this.state.configBilling[billing];
        listProduct[actionKey].text_pricing = text_pricing;
        listProduct[actionKey].text_billing_cycle = text_billing_cycle;
        listProduct[actionKey].chosseBillcycle = billing;
        this.setState({
            listProduct: listProduct
        })
    }

    listBtnGroupProduct = () => {
        // console.log(this.state.listGroupProduct)
        if ( this.state.listGroupProduct.length > 2) {
            return (
                this.state.listGroupProduct.map( (groupProduct, key) => (
                    <Link
                        key={key}
                        className={ "btn btn-primary btn-sm mr-1 my-1 group-product-" + key  }
                        to={ '/san-pham/vps/' + groupProduct.id + '/danh-sach-dich-vu-vps.html' }
                    >
                        { groupProduct.name }
                    </Link>
                ))
            )
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Dịch vụ Cloud VPS"} page={"Dịch vụ cloud vps"} icon={<FaCloud className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <>
                                        <Row>

                                            {
                                                this.checkNotification()
                                            }

                                            <Col lg={12} className="mb-4">
                                                {
                                                    this.listBtnGroupProduct()
                                                }
                                            </Col>

                                            <Col>
                                                <Row className="pricing">
                                                    { this.loadProductVps() }
                                                </Row>
                                            </Col>

                                        </Row>
                                    </>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerProductVps' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListProductVpsByUserPage);